import React, { useMemo } from 'react';
import { Badge } from '../Badge';
import Contact from '@repo/utils/models/Contact';
import styles from './BirthdayBadge.module.scss';
import cn from 'classnames';

interface ContactBirthdayProps {
  contact: Contact;
}
export const BirthdayBadge = ({ className }: { className?: string }) => (
  <Badge src="/img/icons/birthday-no-bg.svg" className={cn(className)} />
);

export function ContactBirthdayBadge({ contact }: ContactBirthdayProps) {
  if (!contact.birthday) {
    return null;
  }

  const age = useMemo(() => contact.age, [contact]);
  const hasAge = !!age && Number(age) > 0;

  return (
    <div className={cn(styles.wrap, hasAge && styles.withAge)}>
      <div className={styles.pill}>
        <BirthdayBadge className={styles.badge} />
        <span className={cn(styles.text, styles.date)}>{contact.formattedBirthday}</span>
        {hasAge && <span className={cn(styles.text, styles.age)}>{age} years</span>}
      </div>
    </div>
  );
}
